import { ModifiableEntityViewModel } from "../../incidents/viewModels/modifiableEntityViewModel";
import { RiskAssesmentPrivacyStatuses } from "../../shared/enums/planning/riskAssesmentPrivacyStatuses";
import { RiskAssesmentStatuses } from "../../shared/enums/planning/riskAssesmentStatuses";
import { RiskAssessmentApprovalHistoryViewModel } from "./riskAssessmentApprovalHistoryViewModel";
import { RiskAssessmentRiskViewModel } from "./riskAssessmentRiskViewModel";

export class RiskAssesmentViewModel extends ModifiableEntityViewModel {
  startDate: string;
  dueDate: string;
  ownerId: number;
  approverId: number;
  status: RiskAssesmentStatuses;
  privacyStatus: RiskAssesmentPrivacyStatuses;
  eventId: number;
  description: string;
  closed: string;
  riskProfileId: number;
  risksCount: number;
  event: {
    id: number;
    title: string;
    startDate: string;
    endDate: string;
    eventTypeTitles: string[];
  }
  riskList: RiskAssessmentRiskViewModel[];
  approvalHistoryViewModels: RiskAssessmentApprovalHistoryViewModel[];
}
